export default () => {
    const getShipto = new URLSearchParams( window.location.search ).get( 'shipto' );
    const getRegion = new URLSearchParams( window.location.search ).get( 'region' );
    const getId = new URLSearchParams( window.location.search ).get( 'id' );
    const getSo = new URLSearchParams( window.location.search ).get( 'so' );
    const getLine = new URLSearchParams( window.location.search ).get( 'line' );

    return {
        account: getShipto ? getShipto : getId ? getId : '',
        region: getRegion ? getRegion : '',
        so: getSo ? getSo : '',
        line: getLine ? getLine : '',
    }
}
